import { useMutation, useQueryClient } from '@tanstack/react-query';
import config from '@/config';
import api from '@/shared/api';
import HandleHttpError from '@/shared/services/HandleHttpError';
import { useIntl } from 'react-intl';
import ToastrService from '@/shared/services/ToastrService';
import { IntraCompanyQueryKey } from './queryKey';
import { useStateService } from '@/shared/services/StateService';
import messages from '../messages';
var useBatchBill = function () {
    var queryClient = useQueryClient();
    var stateService = useStateService();
    var intl = useIntl();
    var _a = useMutation(function (values) {
        return api.base
            .post("".concat(config.appUrls.api, "/api/IntraCompany/BatchBill/"), values)
            .then(function (_a) {
            var data = _a.data;
            return data;
        });
    }, {
        onSuccess: function (data) {
            if (data) {
                queryClient.invalidateQueries([IntraCompanyQueryKey.Overview]);
                var onClick = data.id ? function () { return stateService.gotoJob(data.id); } : undefined;
                ToastrService.info(intl.formatMessage(messages.BackgroundJobQueued), undefined, onClick);
            }
        },
        onError: function (e) {
            HandleHttpError(intl)(e);
        },
    }), mutateAsync = _a.mutateAsync, isLoading = _a.isLoading;
    return { batchBill: mutateAsync, batchBillRunning: isLoading };
};
export default useBatchBill;
